import { useCallback, useState } from 'react';
import { DormitoryLegacyHttp } from '@/services';
import { parseError } from '@/utils';

export default function useAttendanceReport() {
  const [total, setTotal] = useState(0);
  const [items, setItems] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const fetchReport = useCallback(async (page: number, pageSize: number, startDate: string, endDate: string) => {
    // if (!university?.samad?.Attendance) return;
    setLoading(true);
    try {
      const response = await DormitoryLegacyHttp.fetchAttendaneReport(page, pageSize, startDate, endDate);
      setItems(response?.data?.payload?.content ?? []);
      setTotal(response?.data?.payload?.totalElements ?? 0);
    }
    catch (e) {
      setError(parseError(e));
    }
    finally {
      setLoading(false);
    }
  }, [setTotal, setItems, setLoading]);

  const lazyFetchReports = useCallback(async (page: number, pageSize: number, startDate: string, endDate: string) => {
    if (items.length >= total) return false;
    return DormitoryLegacyHttp.fetchAttendaneReport(page, pageSize, startDate, endDate)
      .then(res => {
        setItems(oldItems => [...oldItems, ...(res?.data?.payload?.content ?? [])]);
      });
  }, [items, total, setItems]);

  return { fetchReport, lazyFetchReports, items, loading, error, total };
}
